import React, { Component } from "react";
import "./OurServices.css";
import { Fade } from "react-awesome-reveal";
import { ThemeProps } from "../../components/styles/themeprops";
import { useTranslation } from "react-i18next";

type Props = {
	theme: ThemeProps,
}
export default function OurServices({ theme }: Props) {
	const { t, i18n } = useTranslation();
	return (
		<div className="main ourservices" id="certs">
			<div className="row justify-content-center">
				
				<h2 className="ourservices_h2" style={{textAlign: "center"}}>{t("service.title")}</h2>
				
			</div>
			
			<div className="row justify-content-center">
				<div className="col-lg-4 mb-5">
					<Fade direction="left" duration={1000} triggerOnce={true} className="h-100">
					<div className="textcard-item text-center h-100">
						<div className="textcard-icon">
							<span
								className="iconify"
								data-icon="mdi:account-service"
								style={{ color: "var(--primary)", fontSize: "45px" }}
								data-inline="false"
							></span>
						</div>
						<div className="textcard-headline ">
							<h3>{t("service.1")}</h3>
						</div>
						<div className="textcard-text">
							<p>{t("service.1.desc")}</p>
						</div>
						{/*<div className="textcard-more">
							<a href="/vorteile#c12" title="Mehr erfahren" className="link-dpaii">{t("link.more")}</a>
						</div>*/}
					</div>
					</Fade>
				</div>
				
				<div className="col-lg-4 mb-5">
					<Fade direction="down" duration={1000} triggerOnce={true} className="h-100">
					<div className="textcard-item text-center h-100">
						<div className="textcard-icon">
							<span
								className="iconify"
								data-icon="uil:process"
								style={{ color: "var(--primary)", fontSize: "45px" }}
								data-inline="false"
							></span>
						</div>
						<div className="textcard-headline ">
							<h3>{t("service.2")}</h3>
						</div>
						<div className="textcard-text">
							<p>{t("service.2.desc")}</p>
						</div>
						{/*<div className="textcard-more">
													<a href="/vorteile#c12" title="Mehr erfahren" className="link-dpaii">{t("link.more")}</a>
												</div>*/}
					</div>
					</Fade>
				</div>

				<div className="col-lg-4 mb-5">
					<Fade direction="right" duration={1000} triggerOnce={true} className="h-100">
					<div className="textcard-item text-center h-100">
						<div className="textcard-icon">
							<span
								className="iconify"
								data-icon="hugeicons:passport-valid"
								style={{ color: "var(--primary)", fontSize: "45px" }}
								data-inline="false"
							></span>
						</div>
						<div className="textcard-headline ">
							<h3 style={{ wordWrap: "break-word" }}>{t("service.3")}</h3>
						</div>
						<div className="textcard-text">
							<p>
								{t("service.3.desc")}
							</p>
						</div>
						{/*<div className="textcard-more">
													<a href="/vorteile#c12" title="Mehr erfahren" className="link-dpaii">{t("link.more")}</a>
												</div>*/}
					</div>
					</Fade>
				</div>
				
				<div className="col-lg-4 mb-5">
					<Fade direction="left" duration={1000} triggerOnce={true} className="h-100">
					<div className="textcard-item text-center h-100">
						<div className="textcard-icon">
							<span
								className="iconify"
								data-icon="material-symbols:support" 
								style={{ color: "var(--primary)", fontSize: "45px" }}
								data-inline="false"
							></span>
						</div>
						<div className="textcard-headline ">
							<h3>{t("service.4")}</h3>
						</div>
						<div className="textcard-text">
							<p>{t("service.4.desc")}</p>
						</div>
						{/*<div className="textcard-more">
													<a href="/vorteile#c12" title="Mehr erfahren" className="link-dpaii">{t("link.more")}</a>
												</div>*/}
					</div>
					</Fade>
				</div>
				
				<div className="col-lg-4 mb-5">
					<Fade direction="down" duration={1000} triggerOnce={true} className="h-100">
					<div className="textcard-item text-center h-100">
						<div className="textcard-icon">
							<span
								className="iconify"
								data-icon="oui:integration-general" 
								style={{ color: "var(--primary)", fontSize: "45px" }}
								data-inline="false"
							></span>
						</div>
						<div className="textcard-headline ">
							<h3>{t("service.5")}</h3>
						</div>
						<div className="textcard-text">
							<p>{t("service.5.desc")}</p>
						</div>
						{/*<div className="textcard-more">
													<a href="/vorteile#c12" title="Mehr erfahren" className="link-dpaii">{t("link.more")}</a>
												</div>*/}
					</div>
					</Fade>
				</div>

				<div className="col-lg-4 mb-5">
					<Fade direction="right" duration={1000} triggerOnce={true} className="h-100">
					<div className="textcard-item text-center h-100">
						<div className="textcard-icon">
							<span
								className="iconify"
								data-icon="carbon:development" 
								style={{ color: "var(--primary)", fontSize: "45px" }}
								data-inline="false"
							></span>
						</div>
						<div className="textcard-headline ">
							<h3 style={{ wordWrap: "break-word" }}>{t("service.6")}</h3>
						</div>
						<div className="textcard-text">
							<p>
								{t("service.6.desc")}
							</p>
						</div>
						{/*<div className="textcard-more">
													<a href="/vorteile#c12" title="Mehr erfahren" className="link-dpaii">{t("link.more")}</a>
												</div>*/}
					</div>
					</Fade>
				</div>
				
			</div>

		</div>
	);
}
